module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/hannah-kazerounian-640540b7f198d02a6a2205de34dac931.jpg";